var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconColumns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.17188 13.0156V0.984375C3.17188 0.924219 3.12266 0.875 3.0625 0.875H2.29688C2.23672 0.875 2.1875 0.924219 2.1875 0.984375V13.0156C2.1875 13.0758 2.23672 13.125 2.29688 13.125H3.0625C3.12266 13.125 3.17188 13.0758 3.17188 13.0156ZM11.8125 13.0156V0.984375C11.8125 0.924219 11.7633 0.875 11.7031 0.875H10.9375C10.8773 0.875 10.8281 0.924219 10.8281 0.984375V13.0156C10.8281 13.0758 10.8773 13.125 10.9375 13.125H11.7031C11.7633 13.125 11.8125 13.0758 11.8125 13.0156ZM4.97656 11.5938C4.97656 11.7141 5.075 11.8125 5.19531 11.8125H8.80469C8.925 11.8125 9.02344 11.7141 9.02344 11.5938V2.40625C9.02344 2.28594 8.925 2.1875 8.80469 2.1875H5.19531C5.075 2.1875 4.97656 2.28594 4.97656 2.40625V11.5938ZM8.03906 3.17188V10.8281H5.96094V3.17188H8.03906Z",
    fill: "#052C2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconColumns);
export default __webpack_public_path__ + "static/media/icon_columns.e6cf46d53fb2f5641af478d9f37982fb.svg";
export { ForwardRef as ReactComponent };